import { addMonths, differenceInDays } from 'date-fns';
import React from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { fetchDateRange } from '../utils/api/reports/analytics-requests';
import { DashboardChartHeader } from './components/chart-header';
import { DashboardDatePicker } from './components/dashboard-date-picker';
import { DashboardLineChartType1 } from './components/dashboard-line-chart-type1';

function formatData(data) {
  if (data && data.length > 0) {
    return [
      {
        id: 'Workflow Assignments',
        label: 'Workflow Assignments',
        data: data.map((d) => ({ x: d.date, y: d.count_triggered })),
      },
      {
        id: 'Manual Assignments',
        label: 'Manual Assignments',
        data: data.map((d) => ({ x: d.date, y: d.count_untriggered })),
      },
    ];
  }
  return [];
}

export function AssignmentsFromWorkflowsChart(props) {
  const defaultDateRange = [addMonths(new Date(), -1), new Date()];
  const [dateRange, setDateRange] = React.useState(defaultDateRange);
  const [data, setData] = React.useState([]);
  const [dateRangeError, setDateRangeError] = React.useState('');
  const [showDatePicker, setShowDatePicker] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      if (!dateRange) {
        // If the date range is empty, force it to the default date range and do it again.
        setDateRange(defaultDateRange);
        return;
      }
      const daysDiff = differenceInDays(dateRange[1], dateRange[0]);
      if (daysDiff > 366) {
        setDateRangeError('Date range too large.  Please select a range of 1 year or less.');
        return;
      }
      setDateRangeError('');
      const jsonData = await fetchDateRange(
        props.reportClient,
        '/api/v1/analytics/assignments-from-workflows-counts',
        dateRange
      );
      const formattedData = formatData(jsonData);
      setData(formattedData);

      // We delay showing the datepicker until the rest of the UI is ready in order 
      // to avoid a snapping in the UI as it resizes itself.
      setShowDatePicker(true);
    })();
  }, [dateRange]);

  return (
    <div className="chart-box-flow">
      <div className="chart-box-flow-header">
        <DashboardChartHeader
          title="Assignment Breakdown"
          tooltip="A breakdown of manual and automated (Workflow) assignments."
        />
        <DashboardDatePicker {...{ showDatePicker, dateRange, setDateRange, dateLocale: props.dateLocale }} />
      </div>
      {dateRangeError && <div className="ui message chart-date-error">{dateRangeError}</div>}
      <div className="chart-box-autosizer-wrapper">
        <AutoSizer>
          {({ width, height }) => (
            <DashboardLineChartType1
              data={data}
              width={width}
              height={height}
              singleLegendProps={{
                itemWidth: 150,
              }}
            />
          )}
        </AutoSizer>
      </div>
    </div>
  );
}
